var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useFieldApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-field-api";
import startOfDay from "date-fns/startOfDay";
import React from "react";
import { Select } from "../Select/Select";
import get from "lodash/get";
import find from "lodash/find";
import groupBy from "lodash/groupBy";
import { TimeSlotDropdown } from "./TimeSlotDropdown";
import { TimeSlotFilter } from "./TimeSlotFilter";
import { TimeSlotRows } from "./TimeSlotRows";
import styled from "styled-components";
import { usePresentationComponent } from "../../../AppContext";
import isEqual from "date-fns/isEqual";
import isToday from "date-fns/isToday";
import getDate from "date-fns/getDate";
import isTomorrow from "date-fns/isTomorrow";
import i18next from "i18next";
import { dateFormat, normalizeDate } from "../../../helpers/date";
import { ErrorTypes } from "..";
var filters = [
    { filter: function (hour) { return hour < 12; }, name: "morning" },
    { filter: function (hour) { return hour >= 12 && hour < 16; }, name: "afternoon" },
    { filter: function (hour) { return hour >= 16; }, name: "evening" },
    { filter: function (hour) { return false; }, name: "all" },
];
var getAvailableSlots = function (allSlots, date, options) {
    if (options === void 0) { options = {}; }
    return get(allSlots, date, []).filter(function (_a) {
        var from = _a.from, isAvailable = _a.isAvailable;
        return isAvailable || get(options, "showUnavailableTimeslots", true);
    });
};
var filterSlots = function (allSlots, date, options) {
    if (options === void 0) { options = {}; }
    if (!date)
        return {};
    var slotsToRender = getAvailableSlots(allSlots, date, options);
    if (slotsToRender.length <= get(options, "slotCountWithoutFilter", 30)) {
        return {
            "all": slotsToRender
        };
    }
    return groupBy(slotsToRender, function (_a) {
        var _b;
        var from = _a.from;
        return ((_b = filters.find(function (_a) {
            var filter = _a.filter;
            return filter(from === null || from === void 0 ? void 0 : from.getHours());
        })) === null || _b === void 0 ? void 0 : _b.name);
    });
};
var deriveFilterValue = function (filteredSlots) {
    var _a;
    return (_a = filters.find(function (_a) {
        var name = _a.name;
        return get(filteredSlots, name);
    })) === null || _a === void 0 ? void 0 : _a.name;
};
var TimeSlot = /** @class */ (function (_super) {
    __extends(TimeSlot, _super);
    function TimeSlot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dailySlots: {},
            includedDates: [],
            date: null,
            filter: "morning",
            filteredSlots: {},
            hideSlotSelection: false,
        };
        _this.dateFieldName = "date_" + Math.random();
        _this.selectDate = function (value) {
            var date = value ? startOfDay(Number(value)) : null;
            _this.selectSlot(null);
            _this.setState({ date: date, filter: deriveFilterValue(filterSlots(_this.state.dailySlots, date, { showUnavailableTimeslots: _this.selfProps.showUnavailableTimeslots })) });
        };
        _this.selectFilter = function (filter) {
            if (_this.state.filter === filter)
                return;
            _this.selectSlot(null);
            _this.setState({ filter: filter });
        };
        _this.selectSlot = function (selectedSlot) {
            var value = _this.selfProps.value || null;
            if (value === selectedSlot)
                return;
            _this.selfProps.onChange(selectedSlot || {});
        };
        _this.filterDate = function (date) { return !!_this.state.includedDates.find(function (includedDate) { return isEqual(startOfDay(includedDate), startOfDay(date)); }); };
        _this.handleDropdownSelect = function (key) {
            var _a;
            var slot = (_a = getAvailableSlots(_this.state.dailySlots, _this.state.date)) === null || _a === void 0 ? void 0 : _a.find(function (slot) { return _this.deriveSlotValue(slot) === key; });
            _this.selectSlot(slot);
        };
        return _this;
    }
    Object.defineProperty(TimeSlot.prototype, "selfProps", {
        get: function () {
            return this.props;
        },
        enumerable: false,
        configurable: true
    });
    TimeSlot.prototype.componentDidUpdate = function () {
        var value = this.selfProps.value;
        var _a = this.state, filter = _a.filter, filteredSlots = _a.filteredSlots;
        var hasOnlyOneAvailableSlot = filter === "all" && filteredSlots[filter].length === 1;
        var selectedSlot = hasOnlyOneAvailableSlot ? filteredSlots[filter][0] : null;
        if (selectedSlot && !isEqual(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.from, value === null || value === void 0 ? void 0 : value.from)) {
            this.selectSlot(selectedSlot);
        }
    };
    TimeSlot.getDerivedStateFromProps = function (nextProps, state) {
        var date = nextProps.onDate ? startOfDay(new Date(nextProps.onDate + "T00:00")) : null, dailySlots = groupBy(nextProps.slots, function (slot) { return startOfDay(slot.from); }), filteredSlots = filterSlots(dailySlots, date, { showUnavailableTimeslots: nextProps.showUnavailableTimeslots }), filter = (!!filteredSlots[state.filter] ? state.filter : deriveFilterValue(filteredSlots)) || null, hideSlotSelection = filter === "all" && filteredSlots[filter].length === 1;
        return {
            date: date,
            filter: filter,
            dailySlots: dailySlots,
            filteredSlots: filteredSlots,
            hideSlotSelection: hideSlotSelection,
            includedDates: nextProps.includeDates.map(function (date) {
                var at_00_Hours = startOfDay(date);
                if (!find(get(dailySlots, at_00_Hours), "isAvailable")) {
                    return null;
                }
                return at_00_Hours;
            }).filter(Boolean),
        };
    };
    TimeSlot.prototype.filteredSlots = function () {
        return get(this.state.filteredSlots, this.state.filter, []);
    };
    TimeSlot.prototype.renderDateSelector = function () {
        if (this.selfProps.slots.length === 0)
            return null;
        var inputProps = {
            type: "hidden",
            value: this.state.date,
            filterDate: this.filterDate,
            onChange: this.selectDate,
            label: i18next.t("bookcart.timeslots.select_time_slot_date") || i18next.t("bookcart.timeslots.select_time_slot"),
            required: this.selfProps.required,
            meta: this.selfProps.meta,
            name: this.selfProps.name,
            autocomplete: this.dateFieldName,
            placeholder: i18next.t("bookcart.timeslots.select_time_slot_date_placeholder"),
            isHidden: this.state.includedDates.length < 1,
            options: this.state.includedDates.map(function (date) {
                return {
                    value: date.getTime(),
                    label: i18next.t("bookcart.timeslots.date_label", {
                        date: function () { return getDate(date); },
                        month: function () { return getDate(date); },
                        year: function () { return getDate(date); },
                        day: function () { return isToday(date) ? i18next.t("date.today") : isTomorrow(date) ? i18next.t("date.tomorrow") : dateFormat(date, "cccc"); },
                        value: function () { return dateFormat(date, i18next.t("date.date_format")); },
                        skipInterpolation: true
                    })
                };
            })
        };
        return (React.createElement(Select, __assign({}, inputProps)));
        // return <Input { ...inputProps } />;
    };
    TimeSlot.prototype.renderFilters = function () {
        var _this = this;
        var _a = this.selfProps.meta, error = _a.error, invalid = _a.invalid, touched = _a.touched;
        return (React.createElement(React.Fragment, null,
            touched && error && invalid ? React.createElement(ErrorTypes.Required, { style: { marginBottom: "5px", display: "block" }, label: this.selfProps.label }) : "",
            React.createElement(TimeSlotFilter, { appliedFilter: this.state.filter, filters: filters.map(function (_a) {
                    var name = _a.name;
                    return name;
                }).filter(function (filter) { return _this.state.filteredSlots[filter]; }), onSelect: this.selectFilter })));
    };
    TimeSlot.prototype.renderSlots = function () {
        if (!this.state.date)
            return null;
        return React.createElement(TimeSlotRows, { hideSlotSelection: this.state.hideSlotSelection, slots: this.filteredSlots(), onSelect: this.selectSlot, selected: this.selfProps.value });
    };
    TimeSlot.prototype.renderSlotDropdown = function () {
        if (!this.state.date)
            return null;
        if (this.state.includedDates.length > 0 && !this.state.date)
            return null;
        var dropdownProps = {
            filters: filters,
            meta: this.selfProps.meta,
            slots: getAvailableSlots(this.state.dailySlots, this.state.date),
            selected: this.selfProps.value,
            required: this.selfProps.required,
            onSelect: this.handleDropdownSelect,
            deriveSlotValue: this.deriveSlotValue,
            filteredSlots: this.state.filteredSlots,
            hideSlotSelection: this.state.hideSlotSelection
        };
        return React.createElement(TimeSlotDropdown, __assign({}, dropdownProps));
    };
    TimeSlot.prototype.deriveSlotValue = function (slot) {
        if (!slot.from)
            return "";
        return normalizeDate(slot.from).getTime() + "__" + normalizeDate(slot.to).getTime();
    };
    TimeSlot.prototype.render = function () {
        var Renderer = this.selfProps.Renderer;
        return (React.createElement(Renderer, { hasSlots: !!this.state.date }, this.renderSlotDropdown()));
    };
    TimeSlot.defaultProps = {
        showUnavailableTimeslots: true
    };
    return TimeSlot;
}(React.Component));
export { TimeSlot };
export var ReactiveTimeSlot = function (props) {
    var Renderer = usePresentationComponent("timeslot.timeslot") || TimeslotContainer;
    var _a = useFieldApi(props), input = _a.input, meta = _a.meta;
    return React.createElement(TimeSlot, __assign({}, input, { Renderer: Renderer }, props, { meta: meta }));
};
var TimeslotContainer = styled.div.attrs(function () { return ({ slotsCount: 0 }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var templateObject_1;
